import { render, staticRenderFns } from "./BaseDocumentTag.vue?vue&type=template&id=36f95b2e"
import script from "./BaseDocumentTag.vue?vue&type=script&lang=js"
export * from "./BaseDocumentTag.vue?vue&type=script&lang=js"
import style0 from "./BaseDocumentTag.vue?vue&type=style&index=0&id=36f95b2e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports